// extracted by mini-css-extract-plugin
module.exports =  {"dots":"d2Z0ec"};